<template>
  <div>
    <b-container class="text-center p-0 vh-100 bg-blue-light d-flex justify-content-center">
      <b-row
        class="bg-congrats px-4 py-4 m-0 justify-content-center align-items-center"
      >
        <b-col
          cols="11"
          sm="6"
          class="bg-white px-4 pt-3 pb-1 mb-5 d-flex align-items-center"
        >
          <section>
            <p class="h3 text-uppercase font-weight-bold text-main">
              C o n g r a t s !
            </p>
            <p class="h4">
              You just earned
            </p>

            <section class="d-flex align-items-center justify-content-center my-4">
              <p class="h1 font-weight-bolder text-main text-full">
                {{ getCoins }}
              </p>
              <b-img
                fluid
                :src="require(`@/assets/icons/icon-money-star.png`)"
                class="icon-star-medium h-auto"
              ></b-img>
            </section>

            <p class="h4 mt-3">
              For
              {{ getDescription }}
            </p>
            <p class="h4 text-main my-3">
              Keep it up!
            </p>

            <small>
              Remember that the items must be confirmed in order to obtain the points.
            </small>

            <b-button @click="Next" variant="warning" class="w-100 my-2">
              OK!
            </b-button>
          </section>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data(){
    return {
      getCoins: 12,
      getPoints: 10,
      getDescription: "for completing 3 tasks on your Challenge",
      getParentName: "Parent Name"
    };
  },
  methods: {
    Next() {
      this.$router.replace(this.$route.query.next ?? "/");
    }
  }
};
</script>

<style scoped>
.bg-congrats {
  background-image: url("../../assets/bg-congrats.png");
  background-size: contain;
}
.bg-congrats .bg-white {
  height: 570px;
}
.bg-coin {
  background-image: url("../../assets/icons/icon-money-star.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  color: #f6a724;
}
.bg-coin p {
  font-size: 4.5em;
  padding-top: 21%;
  padding-bottom: 21%;
}
.icon-star-medium {
  width: 3.5em;
}
.text-full{
  font-size: 5em;
}
</style>
